import { getProvider } from '@/apollo'
import gql from 'graphql-tag'

const STATUS_LOADED = 'LOADED'
const STATUS_ERROR = 'ERROR'

const ModalsModule = {
  namespaced: true,
  state: {
    loadingStatus: {
      aggregatedConsents: ''
    },
    aggregatedConsents: {
      inquire: {
        adConsent: false,
        passData: false
      }
    },
    activeModal: ''
  },
  actions: {
    async trackAggregatedConsents (
      {
        commit,
        state
      }
    ) { // initialize
      commit('clearMessages', {}, { root: true })
      const apolloClient = getProvider().defaultClient
      return apolloClient.query({
        query: gql`query trackAggregatedConsents {
        trackAggregatedConsents {
          inquire {
        adConsent,
        passData
          }
        }
      }`
      }).then((response) => {
        commit('setAggregatedConsents', response.data)
        commit('setAggregatedConsentsLoadingStatus', STATUS_LOADED)
      }).catch(() => {
        commit('setAggregatedConsentsLoadingStatus', STATUS_ERROR) // kein error handling, da login trotzdem erforderlich
      })
    }
  },
  mutations: {
    setAggregatedConsents (state, aggregatedConsents) {
      state.aggregatedConsents.inquire.adConsent = aggregatedConsents.trackAggregatedConsents.inquire.adConsent
      state.aggregatedConsents.inquire.passData = aggregatedConsents.trackAggregatedConsents.inquire.passData
    },
    setAggregatedConsentsLoadingStatus: (state, status) => {
      state.loadingStatus.aggregatedConsents = status
    },
    setActiveModal: (state, name) => {
      state.activeModal = name
    }
  },
  getters: {
    getAggregatedConsents: state => {
      return state.aggregatedConsents
    },
    getLoadingStatus: state => {
      return state.loadingStatus
    },
    getActiveModal: state => {
      return state.activeModal
    }
  }
}

export {
  ModalsModule
}
